import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ProductShowcase } from './components/ProductShowcase';
import { VolumesDetail } from './components/VolumesDetail';
import { GestionSection } from './components/GestionSection';
import { BonusesSection } from './components/BonusesSection';
import { CountdownSection } from './components/CountdownSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { FooterSection } from './components/FooterSection';
import { PurchaseNotification } from './components/PurchaseNotification';
// Inject preconnect hints immediately (before React renders)
if (typeof document !== 'undefined') {
  const head = document.head;
  const preconnectGoogle = document.createElement('link');
  preconnectGoogle.rel = 'preconnect';
  preconnectGoogle.href = 'https://fonts.googleapis.com';
  head.insertBefore(preconnectGoogle, head.firstChild);
  const preconnectGstatic = document.createElement('link');
  preconnectGstatic.rel = 'preconnect';
  preconnectGstatic.href = 'https://fonts.gstatic.com';
  preconnectGstatic.crossOrigin = 'anonymous';
  head.insertBefore(preconnectGstatic, head.firstChild);
  const preconnectCDN = document.createElement('link');
  preconnectCDN.rel = 'preconnect';
  preconnectCDN.href = 'https://cdn.magicpatterns.com';
  head.insertBefore(preconnectCDN, head.firstChild);
  // Preload hero image immediately (outside useEffect for earliest possible discovery)
  const preloadImg = document.createElement('link');
  preloadImg.rel = 'preload';
  preloadImg.as = 'image';
  preloadImg.href = 'https://cdn.magicpatterns.com/uploads/4RNMGryCsfyVfk5DBR6qtW/Sin_titulo_(420_x_420_px)_(2).png';
  preloadImg.type = 'image/png';
  head.insertBefore(preloadImg, head.firstChild);
}
export function App() {
  useEffect(() => {
    // Load fonts asynchronously — non-render-blocking
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap';
    fontLink.media = 'print';
    fontLink.onload = function () {
      ;
      (this as HTMLLinkElement).media = 'all';
    };
    document.head.appendChild(fontLink);
    // Defer Meta Pixel to idle time
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(() => loadPixel(), {
        timeout: 10000
      });
    } else {
      setTimeout(loadPixel, 8000);
    }
  }, []);
  return <main className="font-body text-white bg-brand-dark overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPointsSection data-id="element-2" />
      <ProductShowcase data-id="element-3" />
      <VolumesDetail data-id="element-4" />
      <GestionSection data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <CountdownSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <FinalCTASection data-id="element-12" />
      <FooterSection data-id="element-13" />
      <PurchaseNotification data-id="element-14" />
    </main>;
}
function loadPixel() {
  if (typeof window !== 'undefined' && !(window as any).fbq) {
    const f = window as any;
    const n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', '1170774765082882');
    (window as any).fbq('track', 'PageView');
  }
}